import { render, staticRenderFns } from "./TableFieldsRestoreContainer.vue?vue&type=template&id=612923c2&scoped=true&"
import script from "./TableFieldsRestoreContainer.vue?vue&type=script&lang=js&"
export * from "./TableFieldsRestoreContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612923c2",
  null
  
)

export default component.exports